import { Loader2 } from "lucide-react";
import { useAuth } from "@/hooks/use-auth";
import { useProfileSettings } from "@/hooks/use-profile-settings";
import { ProfileInformationCard } from "./ProfileInformationCard";

export function ProfileSettings() {
  // Get current user from auth hook
  const { user, isLoading } = useAuth();
  
  // Get profile settings state and logic from custom hook
  const {
    isEditing,
    formData,
    setFormData,
    handleSubmit,
    handleCancel,
    handleEdit,
    updateMutation,
  } = useProfileSettings(user);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto space-y-6">
      <ProfileInformationCard
        user={user}
        isEditing={isEditing}
        formData={formData}
        isPending={updateMutation.isPending}
        onFormDataChange={setFormData}
        onEdit={handleEdit}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </div>
  );
}
